import { render, staticRenderFns } from "./AddNewCompanyAddressPopUp.vue?vue&type=template&id=53e7f564&scoped=true&"
import script from "./AddNewCompanyAddressPopUp.vue?vue&type=script&lang=js&"
export * from "./AddNewCompanyAddressPopUp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53e7f564",
  null
  
)

export default component.exports